<template>
  <div style="height: 40vh;position: relative;">
    <div class="box">
      <div class="words">
        <div>
          当日计划:
          <span style="font-size: 1em">
            {{totalKanbanVo.currentDayPlanNum}}
          </span>
        </div>
        <div style="margin-top:5px">
          当日完成:
          <span style="font-size: 1em">
            {{totalKanbanVo.currentDayNum}}
          </span>
        </div> 
      </div>
      <div class="chart" :class="chartClass"/>
    </div>
    <div class="box">
      <div class="words2">
        <div>
          当月计划:
          <span style="font-size: 1em">
            {{totalKanbanVo.currentMonthPlanNum}}
          </span>
        </div>
        <div style="margin-top:5px">
          当月完成:
          <span style="font-size: 1em">
            {{totalKanbanVo.currentMonthNum}}
          </span>
        </div> 
      </div>
      <div class="chart" :class="chartClass2"/>
    </div>
  </div>
</template>
<script>
  export default {
    name:"",
    props:{
      totalKanbanVo:{
        type: Object,
      },
      chartClass:{
        type:String,
        default:"",
      },
      chartClass2:{
        type:String,
        default:"",
      },
    },
  };
</script>
<style scoped>
</style>